import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { Library, PaginatedResponse } from '../types';
import Spinner from '../components/Spinner';
import EmptyState from '../components/EmptyState';

export default function AnomalyList() {
  const [libraries, setLibraries] = useState<Library[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.get<PaginatedResponse<Library>>('/libraries?status=active')
      .then((res) => setLibraries(res.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner text="Loading anomalies..." />;
  if (error) return <p className="error">{error}</p>;

  return (
    <div>
      <h1>Anomalies</h1>
      <p className="text-muted">Libraries flagged as statistical outliers (&gt;2&sigma; from mean uniqueness).</p>
      {libraries.length === 0 ? (
        <EmptyState
          title="No anomalies yet"
          description="Run the ingest and stats pipelines first. Libraries with unusual collection patterns will appear here."
        />
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Library</th>
              <th>City, State</th>
              <th>Uniqueness Score</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {libraries.map((lib) => (
              <tr key={lib.id}>
                <td><Link to={`/libraries/${lib.id}`}>{lib.name}</Link></td>
                <td>{lib.city}, {lib.state}</td>
                <td>
                  {lib.library_stats?.[0]?.uniqueness_score != null
                    ? lib.library_stats[0].uniqueness_score.toFixed(4)
                    : <span className="text-muted">No stats</span>}
                </td>
                <td><Link to={`/libraries/${lib.id}`}>Research Dossier</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
